// Local dev-auth mode — pairs with the backend's guarded SCRIBE_DEV_AUTH=1 bypass
// (see backend/src/scribe/api/auth.py) so the web app can be exercised end-to-end against a
// locally-run backend without a real Entra app registration existing yet.
//
// This is DISTINCT from `dev:mock` (src/lib/mock.ts), which never talks to a backend at all.
// Local dev-auth mode still makes real HTTP calls to a local backend — it just skips the
// real MSAL/Entra sign-in flow and sends a fixed placeholder bearer token that the backend
// only accepts when it is *also* explicitly running with SCRIBE_DEV_AUTH=1.
//
// Guardrails mirroring the backend's:
//   - only active when VITE_LOCAL_AUTH === '1', and only in dev builds (import.meta.env.DEV)
//     — a production `vite build` compiles this to a constant `false`, same guarantee
//     isMock() relies on.
//   - the token sent is an obviously-fake placeholder string, never anything that could be
//     mistaken for a real credential.
export function isLocalAuth(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_LOCAL_AUTH === '1';
}

/** Fixed placeholder bearer credential for local dev-auth mode. The backend's
 * SCRIBE_DEV_AUTH=1 path does not actually validate this value — it bypasses real token
 * verification entirely and authenticates as a configurable local dev principal — but we
 * still send a clearly-fake, non-empty string so nothing downstream mistakes this for a
 * missing-auth-header case. */
export const LOCAL_AUTH_TOKEN = 'scribe-dev-local-bypass-token';

export const localAuthUser = {
  displayName: import.meta.env.VITE_LOCAL_AUTH_NAME || 'Local Dev User',
  email: import.meta.env.VITE_LOCAL_AUTH_EMAIL || 'dev-local@scribe.invalid',
};
